import React, { FC, useContext } from "react";
import { connect } from 'react-redux'
import { List } from 'semantic-ui-react';

import { BookingAccommodation } from "../../../common/types/accommodation";
import AmountProvider from "../../Provider/AmountProvider";
import MomentCustomer from "../../MomentCustomer/MomentCustomer";

import { RootDispatch, RootState } from "../../../../src/store";
import Utility from "../../../../src/Utility";
import GlobalContext from "../../../contexts/GlobalContext";

const mapProps = (state: RootState) => ({
  bookingFolder: state.booking.bookingFolder
});

type Props = {
  bookingAccommodations: BookingAccommodation[]
} & ReturnType<typeof mapProps>;

const BookingAccommodationList: FC<Props> = ({
  bookingAccommodations,
  bookingFolder,
}) => {
  const [globalContext] = useContext(GlobalContext) as any;

  return (
    <List divided verticalAlign='middle'>
      {bookingAccommodations.map((accommodation, index) => {

        return (
          <List.Item key={index}>
            <List.Content floated='left'>
              <List.Header>
                <MomentCustomer>{accommodation.date}</MomentCustomer>
              </List.Header>
            </List.Content>
            <List.Content floated='right'>
              {// ajouter isNote sur les accomodation !!!!!!!!!!!!!!!!
                bookingFolder?.noteSecondaire && !accommodation?.isNote ? (
                  Utility.ucFirst(globalContext.translations.includedValue)
                ) : (
                  <AmountProvider amount={accommodation.totalAmount} currency={accommodation.currency} />
                )
              }
              
            </List.Content>
          </List.Item>
        )
      })}
    </List>
  )
}

//export default BookingAccommodationList
export default connect(mapProps)(BookingAccommodationList)